import React, { useState } from "react";
import "./Contact.css";

const Contact = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        message: "",
    });
    const [isMapExpanded, setIsMapExpanded] = useState(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const recipient = "info@vajraiot.com";
        const subject = `Contact Form Submission from ${formData.name}`;
        const body = `
            Name: ${formData.name}
            Email: ${formData.email}
            Message: ${formData.message}
        `.trim();

        const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(recipient)}&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
        window.open(gmailUrl, "_blank");
        setFormData({ name: "", email: "", message: "" });
        alert("Gmail will open in a new tab. Please click 'Send' to submit your message!");
    };

    const handleMapClick = () => {
        setIsMapExpanded(true);
    };

    const handleCloseMap = () => {
        setIsMapExpanded(false);
    };

    return (
        <div className="contact-page">
            <div className="contact-header">
                <h1>Contact</h1>
                <p>We’d love to help!</p>
                <p>We love discussing ideas with new and creative people. Feel free to reach out to us anytime!</p>
            </div>

            <div className="contact-content">
                {/* Contact Form */}
                <div className="contact-form">
                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <div className="input-with-icon">
                                <i className="fas fa-user"></i>
                                <input
                                    type="text"
                                    placeholder="Your Name"
                                    className="contact-input"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>
                        </div>
                        <div className="form-group">
                            <div className="input-with-icon">
                                <i className="fas fa-envelope"></i>
                                <input
                                    type="email"
                                    placeholder="Email"
                                    className="contact-input"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>
                        </div>
                        <div className="form-group">
                            <div className="input-with-icon">
                                <i className="fas fa-comment-dots"></i>
                                <textarea
                                    placeholder="Message"
                                    className="contact-textarea"
                                    name="message"
                                    value={formData.message}
                                    onChange={handleInputChange}
                                    required
                                ></textarea>
                            </div>
                        </div>
                        <button type="submit" className="contact-button">Send</button>
                    </form>
                </div>

                {/* Hyderabad Office - Separate Box */}
                <div className="contact-details">
                    <h3>VajraIoT - Hyderabad</h3>
                    <p>3rd Floor, Door No: 2-52/2/24, Megha Hills, Madhapur, Hyderabad, Telangana 500081, India</p>
                    <p>
                        Phone: +91 4042310720 <span className="timings">(9:30 am – 6:30 pm)</span>
                    </p>
                 
                    <p>Email: info@vajraiot.com</p>
                </div>

                {/* Vijayawada Office - Separate Box Beside Hyderabad */}
                <div className="contact-details vijayawada-box">
                    <h3>VajraIoT - Vijayawada</h3>
                    <p> Flat No:14-703/1-501, MANIKYA NAGAR, 4th Lane, Kanuru,Vijayawada, NTR, Andhra Pradesh 520007, India</p>
                    {/* <p>
                        Phone: +91 4042310720 <span className="timings">(9:30 am – 6:30 pm)</span>
                    </p> */}
                  
                    <p>Email: info@vajraiot.com</p>
                </div>
            </div>

            <div className="contact-map">
                <h3>Our Location</h3>
                <div className="map-container" onClick={handleMapClick}>
                    <iframe
                        title="VajraIoT Location"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.289717676219!2d78.39061471487794!3d17.44162788804473!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTfCsDI2JzI5LjkiTiA3OMKwMjMnMjguOCJF!5e0!3m2!1sen!2sin!4v1634567890123"
                        width="100%"
                        height="300"
                        style={{ border: 0 }}
                        allowFullScreen=""
                        loading="lazy"
                    ></iframe>
                </div>
            </div>

            {isMapExpanded && (
                <div className="map-overlay">
                    <div className="expanded-map">
                        <button className="close-map-button" onClick={handleCloseMap}>Close</button>
                        <iframe
                            title="VajraIoT Location Expanded"
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.289717676219!2d78.39061471487794!3d17.44162788804473!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTfCsDI2JzI5LjkiTiA3OMKwMjMnMjguOCJF!5e0!3m2!1sen!2sin!4v1634567890123"
                            width="100%"
                            height="100%"
                            style={{ border: 0 }}
                            allowFullScreen=""
                            loading="lazy"
                        ></iframe>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Contact;